module.exports = __webpack_public_path__ + "img/logo-white.3ed60e79.png";